import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative flex h-9 items-center rounded-md px-3 text-sm font-medium transition-colors ${
      isActive
        ? "text-primary-600"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-extrabold tracking-tight text-foreground-950">91影视</span>
            <span className="text-[10px] font-label tracking-[0.2em] text-foreground-400">YINGSHI</span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden w-72 items-center md:flex">
          <div className="flex w-full items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 focus-within:border-primary-400">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索影片、演员、导演"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="shrink-0 whitespace-nowrap rounded-full bg-secondary-500 px-3 py-1 text-xs font-semibold text-foreground-950 transition-colors hover:bg-secondary-600"
            >
              搜索
            </button>
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 md:hidden"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden animate-slide-down">
          <form onSubmit={handleSearch} className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索影片、演员、导演"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button type="submit" className="shrink-0 whitespace-nowrap rounded-full bg-secondary-500 px-3 py-1 text-xs font-semibold text-foreground-950">
              搜索
            </button>
          </form>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex h-11 items-center rounded-md px-4 text-sm font-medium ${
                    isActive ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}